<div class="form-group">
    <label class="label-for-pair {{large ? 'label-for-pair--large' : '' }}" for="{{label}}">
        <span style="font-weight:400" class="text-danger">{{required ? '* ' : '' }}</span>
        {{label | translate}}
    </label>
    <div style="width:100%" class="input-group {{large ? 'input-group-lg ' : '' }}">
        <span *ngIf="icon" class="input-group-addon" [innerHTML]="icon"></span>
        <select name="{{label}}"
                [(ngModel)]="model"
                (ngModelChange)="onChanges($event)"
                [attr.required]="required ? true : null"
                [attr.disabled]="disabled ? true : null"
                id="{{label}}" class="form-control {{invalid ? 'input--errored' : '' }}">
            <option *ngFor="let option of options" [ngValue]="option.value">{{option.name | translate}}</option>
        </select>
    </div>
</div>